<style lang="scss">
#f-detail {
  .modal-header {
    background: #389ad4;
    padding: 16px 20px;
    border-bottom: none;

    .modal-title {
      color: #fff !important;
      font-size: 15px;
      font-weight: 600;
    }

    .close {
      color: rgba(255,255,255,0.8) !important;
      opacity: 1;
      text-shadow: none;
      &:hover { color: #fff !important; }
    }
  }

  .modal-body {
    padding: 20px 24px;
    background: #f8fafd;
  }

  .modal-footer {
    background: #fff;
    border-top: 1px solid #eef0f8;
    padding: 12px 20px;
  }

  .field-section {
    background: #fff;
    border-radius: 10px;
    border: 1px solid #e8edf5;
    padding: 16px 16px 4px;
    margin-bottom: 16px;

    .section-label {
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.7px;
      color: #389ad4;
      margin-bottom: 14px;
      display: flex;
      align-items: center;
      gap: 6px;

      &::after {
        content: '';
        flex: 1;
        height: 1px;
        background: #eef0f8;
      }
    }
  }

  .form-group {
    margin-bottom: 14px;

    label {
      font-size: 12px;
      font-weight: 600;
      color: #4a5568;
      margin-bottom: 5px;
      display: block;
    }

    .form-control {
      height: 40px;
      border: 1.5px solid #dde2ec;
      border-radius: 8px;
      font-size: 13px;
      color: #0d1b3e;
      transition: border-color 0.2s, box-shadow 0.2s;

      &:focus {
        border-color: #389ad4;
        box-shadow: 0 0 0 3px rgba(56, 154, 212, 0.1);
      }

      &.border-danger {
        border-color: #e53e3e !important;
        box-shadow: 0 0 0 3px rgba(229, 62, 62, 0.08);
      }
    }

    .text-danger { font-size: 11px; margin-top: 3px; display: block; }
  }

  .btn-save {
    background: #389ad4;
    border: none;
    color: #fff;
    font-weight: 600;
    font-size: 13px;
    padding: 8px 20px;
    border-radius: 8px;
    cursor: pointer;
    transition: opacity 0.2s;
    &:hover { opacity: 0.9; }
  }

  .btn-cancel {
    background: #fff;
    border: 1.5px solid #dde2ec;
    color: #4a5568;
    font-weight: 600;
    font-size: 13px;
    padding: 8px 20px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;
    &:hover { background: #f5f7fa; border-color: #c5cfe0; }
  }
}
</style>

<template>
  <b-modal
    id="f-detail"
    no-close-on-backdrop
    centered
    size="lg"
    v-model="showModal"
    :title="is_edit ? 'Update Service Code' : 'Add Service Code'"
  >
    <div>
      <!-- Basic info -->
      <div class="field-section">
        <div class="section-label"><i class="fa fa-tag"></i> Basic Info</div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Title <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                v-model="servicecode.service_name"
                :class="errors['service_name'] ? 'border-danger' : ''"
                placeholder="e.g. FBI Background Check"
              />
              <span v-if="errors['service_name']" class="text-danger">{{ errors["service_name"][0] }}</span>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>Code <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                v-model="servicecode.code"
                :class="errors['code'] ? 'border-danger' : ''"
                placeholder="e.g. FBI001"
              />
              <span v-if="errors['code']" class="text-danger">{{ errors["code"][0] }}</span>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>Delete In (Days) <span class="text-danger">*</span></label>
              <input
                type="number"
                class="form-control"
                v-model="servicecode.days"
                :class="errors['days'] ? 'border-danger' : ''"
                placeholder="90"
              />
              <span v-if="errors['days']" class="text-danger">{{ errors["days"][0] }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Pricing -->
      <div class="field-section">
        <div class="section-label"><i class="fa fa-dollar"></i> Pricing Defaults</div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>Default Cost <span class="text-danger">*</span></label>
              <input
                type="number"
                class="form-control"
                v-model="servicecode.default_cost"
                :class="errors['default_cost'] ? 'border-danger' : ''"
                placeholder="0.00"
              />
              <span v-if="errors['default_cost']" class="text-danger">{{ errors["default_cost"][0] }}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>Default Markup <span class="text-danger">*</span></label>
              <input
                type="number"
                class="form-control"
                v-model="servicecode.default_markup"
                :class="errors['default_markup'] ? 'border-danger' : ''"
                placeholder="0.00"
              />
              <span v-if="errors['default_markup']" class="text-danger">{{ errors["default_markup"][0] }}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>Default Tax <span class="text-danger">*</span></label>
              <input
                type="number"
                class="form-control"
                v-model="servicecode.default_tax"
                :class="errors['default_tax'] ? 'border-danger' : ''"
                placeholder="0.00"
              />
              <span v-if="errors['default_tax']" class="text-danger">{{ errors["default_tax"][0] }}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>Expedited Cost <span class="text-danger">*</span></label>
              <input
                type="number"
                class="form-control"
                v-model="servicecode.default_expedited_cost"
                :class="errors['default_expedited_cost'] ? 'border-danger' : ''"
                placeholder="0.00"
              />
              <span v-if="errors['default_expedited_cost']" class="text-danger">{{ errors["default_expedited_cost"][0] }}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>Expedited Markup <span class="text-danger">*</span></label>
              <input
                type="number"
                class="form-control"
                v-model="servicecode.default_expedited_markup"
                :class="errors['default_expedited_markup'] ? 'border-danger' : ''"
                placeholder="0.00"
              />
              <span v-if="errors['default_expedited_markup']" class="text-danger">{{ errors["default_expedited_markup"][0] }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template #modal-footer>
      <div class="w-100 d-flex justify-content-end gap-2" style="gap: 8px;">
        <button class="btn-cancel" @click="close()">Cancel</button>
        <button class="btn-save" @click="save()">
          <i class="fa fa-check mr-1"></i>
          {{ is_edit ? 'Update' : 'Save' }}
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import { CREATE_SERVICECODES } from "../../../core/services/store/actions.type";

export default {
  props: {
    showModal: { type: Boolean, default: false },
    is_edit: { type: Boolean, default: false },
    servicecode: {
      type: Object,
      default: () => ({
        service_name: "",
        id: 0,
        code: "",
        days: "",
        default_markup: "",
        default_tax: "",
        errors: []
      })
    }
  },
  data() {
    return { errors: [] };
  },
  components: {},
  computed: {
    ...mapGetters([])
  },
  methods: {
    close() {
      this.$emit("closemodal");
    },
    save() {
      this.$store
        .dispatch(CREATE_SERVICECODES, this.servicecode)
        .then(() => {
          this.$toastr.s(this.is_edit ? "Service code successfully updated" : "Service code successfully created");
          this.$emit("closemodal");
        })
        .catch(err => {
          this.errors = err.data;
        });
    }
  }
};
</script>
